<script type="ts">
    import { Modal, ProgressBar } from "carbon-components-svelte";
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";

	const { getTranslation } = stores();

    export let showProgress;
    export let progress;
    export let progressText;
</script>

<Modal
    size="xs"
    bind:open={showProgress}
    modalHeading={$getTranslation("progress-title").value}
    passiveModal
    preventCloseOnClickOutside
    on:open
    on:close
>
    <div class="modal-content-wrapper">
        <ProgressBar
            value={progress}
            helperText={$getTranslation(progressText).value} 
        />
    </div>
</Modal>